<div class="flex flex-col justify-center items-center">
  <div>{{utils.traslatei18n('ERROR')}}</div>
  <div class="flex flex-row font-thin text-sm">
    <div>{{utils.traslatei18n('loginError')}}</div>
    <div class="absolute top-0 right-0">
      <button mat-icon-button (click)="snackBarRef.dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>